import { PageTable, Header } from "/src/layouts/page";
import ModalManager from "@ebay/nice-modal-react";
import NiceModal from "@ebay/nice-modal-react";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";

import { useNavigate } from "react-router-dom";
import capitalizeFirstLetter from "../../../../../utils/capitalizeFirstLetter";
import { formatDate } from "/src/utils/formatDate";
import Table from "/src/components/table";
import "./ChannelTable.css";
import "/src/components/UI/Button/IconButton/IconButton.css";
import channelService from "../../services/channelService";
import Icons from "../../../../phone/data/types/Icons";
import ChannelModal from "../ChannelModal/ChannelModal";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import getCutToken from "/src/utils/getCutToken";
import hasPermission from "/src/utils/hasPermission";

function ChannelTable() {
    const { getChannels, deleteChannel } = channelService;

    const navigate = useNavigate();
    const toast = useToastDispatchContext();

    /*
    const getChannelByName = async (name,data) => {
        return getChannel(name, data);
    }
    const getNumberOfChannels = async (name) =>{
        let val = await getChannelByName(name).then((value) => console.log(Object.values(value)[0].data.length)) ;
    }  
    */
    const cells = [
        {
            column: "CHANNEL",
            name: "type.name",
            show: (value) => <img srcSet={Icons[value]}></img>,
        },
        {
            column: "NAME",
            name: "name",
            sort: true,
            show: (value) => capitalizeFirstLetter(value),
        },
        {
            column: "BOT NAME",
            name: "bot.name",
            sort: true,
            show: (value) => capitalizeFirstLetter(value),
        },
        {
            column: "CHANNEL TOKEN",
            name: "key",
            show: (value) => (
                <span
                    style={{ color: "var(--main)", cursor: "pointer" }}
                    onClick={(e) =>
                        navigator.clipboard.writeText(value).then((_) => {
                            toast.success("Copy token to clipboard", "You can paste this token where you need !", 5000);
                        })
                    }>
                    {" "}
                    {getCutToken(value)}
                </span>
            ),
        },
        {
            column: "AVAILABLE SINCE",
            name: "updated_at",
            sort: true,
            show: (value) => formatDate(value),
        },
    ];

    const showWebEditModal = ({ updateRow, row }) => {
        NiceModal.show(ChannelModal, {
            data: { ...row },
        }).then((channel) => {
            updateRow(channel);
            console.log("t");
        });
    };

    const onClickRedirect = ({ row }) => navigate(urlWithRoutingCompany("supervision/conversations/list/"));
    const onClickRedirectToAnalytics = ({ row }) =>
        navigate(urlWithRoutingCompany("supervision/analytics/" + row.name));
    const onClickAdd = ({ deleteRow, row }) => navigate(urlWithRoutingCompany("channel/create"));

    const onClickDelete = async ({ row, deleteRow }) => {
        const { id, name } = row;

        await ModalManager.show(ApiModal, {
            title: "Delete channel " + name,
            body: "Do you really want to delete the channel " + name,
            api: {
                request: deleteChannel,
                param: [id],
            },
            buttons: [
                { className: "validate", label: "Cancel" },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
            confirm: {
                name: name,
                fieldName: "the channel",
            },
        }).then(() => deleteRow(id));
    };

    const actions = [
        hasPermission("update_channel")
            ? { className: "fas fa-cog action-button edit_action", style: {}, onClick: showWebEditModal }
            : null,
        hasPermission("view_conversations")
            ? {
                  className: "fas fa-comments action-button profil_action conversation_redirection_channel",
                  style: {},
                  onClick: onClickRedirect,
              }
            : null,
        hasPermission("view_analytics")
            ? {
                  className: "fas fa-chart-pie action-button profil_action conversation_redirection_channel",
                  style: {},
                  onClick: onClickRedirectToAnalytics,
              }
            : null,
        hasPermission("delete_channel")
            ? { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete }
            : null,
    ].filter((action) => action);

    const buttons = [hasPermission("create_channel") ? { icon: "fas fa-plus", onClick: onClickAdd } : null].filter(
        (button) => button
    );

    const filters = [{ type: "input", placeholder: "term", name: "name" }];

    return (
        <PageTable>
            <Header title="List of Bots Connected to channels"></Header>
            <div className="entete-dataset">
                <div className="entete-dataset" style={{ width: "115px" }}></div>
            </div>

            <Table
                className="channel"
                name="Channel"
                cells={cells}
                api={getChannels}
                actions={actions}
                buttons={buttons}
                filters={filters}></Table>
        </PageTable>
    );
}

export default ChannelTable;
